"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "I'm very thankful to Dr Zanos. I came as I did not feel my leg from knee to foot. After 3 sessions I started to feel my leg and to feel good myself.",
  author: "Paivm · Google review",
  img: ""
}, {
  quote: "I work out and hike/run quite a lot. Have received amazing care at Bodywerks. It has helped me a lot keeping my body aligned and out of trouble.",
  author: "Pablo M. · Google review",
  img: ""
}, {
  quote: "Months of physiotherapy can't even start solving the problem of what just a session at this chiropractor can.",
  author: "C M. · Google review",
  img: ""
}];
export default function CustomerTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="20951" id="patient-testimonials" ref={ref} className={cn("bg-accent py-[140px] transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl">
          <Carousel opts={{
          align: "center",
          loop: true
        }} orientation="vertical" className="relative flex flex-col items-center justify-center">
            <CarouselContent className="h-[360px]">
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="flex flex-col items-center justify-center py-4 text-center">
                  <blockquote className="font-serif text-3xl italic leading-relaxed text-accent-foreground sm:text-4xl">
                    &ldquo;{item.quote}&rdquo;
                  </blockquote>
                  <div className="mt-10 flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-14 border border-white/20 shadow-lg">
                      <AvatarImage src={item.img} alt={item.author} className="object-cover" />
                      <AvatarFallback className="bg-white/10 text-white">
                        {item.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <cite className="font-sans text-xs font-bold tracking-[0.2em] text-accent-foreground/90 uppercase not-italic">
                      {item.author}
                    </cite>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <CarouselPrevious className="border-white/30 text-white hover:bg-white/10 hover:text-white [&_svg]:stroke-[1]" />
            <CarouselNext className="border-white/30 text-white hover:bg-white/10 hover:text-white [&_svg]:stroke-[1]" />
          </Carousel>
        </div>
      </div>
    </section>;
}